import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Gen AI 360", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { align: "justify" }, [
  /*#__PURE__*/_createTextVNode(" The bot was developed for the (free) "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://learn.activeloop.ai/collections" }, "GenAI 360 course suite"),
  /*#__PURE__*/_createTextVNode(", a Foundational Model Certification, produced by Towards AI in collaboration with Activeloop and the Intel Disruptor Initiative with its most recent Free Course on "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://learn.activeloop.ai/courses/llms" }, "Training and fine-tuning Large Language Models (LLMs) for Production!"),
  /*#__PURE__*/_createTextVNode(" This course is for you if you want to learn how to train and fine-tune LLMs from scratch, and have intermediate Python knowledge as well as access to moderate compute resources (for some cases, just a Google Colab will suffice!). ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("iframe", {
  width: "100%",
  height: "300px",
  src: "https://www.youtube.com/embed/iaYtuh5axJc",
  title: "Train & Fine-Tune Language Models for Production Course by Activeloop, Towards AI & Intel Disruptor",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
  allowfullscreen: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "mx-4" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6",
            class: "pa-0 pr-2"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_v_btn, {
                href: "https://learn.activeloop.ai/courses/llms",
                class: "my-10",
                variant: "outlined",
                style: {"font-size":"1rem"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Start the course now "),
                  _createVNode(_component_v_icon, { class: "ml-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-arrow-right")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "12",
            md: "6",
            class: "pa-0 pl-2"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}